<template>
    <div class="automation-wizard-form">
        <div class="automation-wizard-form__step">
            <Heading
                v-if="currentStep.title"
                :labelTitle="currentStep.title"
                variant="h3"
                :prefixColoredIcon="stepColoredIcon"
                class="automation-wizard-form__heading"
            />
            <CompassAlert
                v-if="currentStep.information"
                type="neutral"
                :description="currentStep.information"
                :showClose="false"
                class="automation-wizard-form__information"
            />
            <div class="automation-wizard-form__field-group">
                <AutomationWizardFormField
                    v-for="(field, index) in visibleFields"
                    :key="index"
                    :field="field"
                    :modelValue="getFieldValue(field.id)"
                    :formData="formData"
                    @update:model-value="updateFieldValue(field.id, $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AutomationWizardFormField from 'vcomponents/automation/templates/Wizard/Form/AutomationWizardFormField.vue';
import Heading from 'vcomponents/common/Heading/Heading.vue';

export default {
    components: {
        AutomationWizardFormField,
        Heading,
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        currentStep: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue', 'field-change'],
    computed: {
        formData: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        stepColoredIcon() {
            const iconMap = {
                trigger: 'flash',
                action: 'target',
            };
            const icon = iconMap[this.currentStep.type] || '';
            const color = this.currentStep.type === 'trigger' ? 'teal' : 'coral';
            return {
                icon,
                color,
            };
        },
        visibleFields() {
            return (this.currentStep.fields || []).filter((field) => field.type !== 'hidden');
        },
    },
    methods: {
        getFieldValue(fieldName) {
            return this.formData[fieldName];
        },
        updateFieldValue(fieldName, value) {
            this.formData[fieldName] = value;
            this.$emit('field-change', fieldName);
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-form {
    &__heading {
        margin: 0 0 var(--spacing-4);
    }
    &__information {
        margin: 0 0 var(--spacing-3);
    }
    &__field-group {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
    }
}
</style>
